export default "__VITE_ASSET__CJhnEIx9__"